import React, {FunctionComponent} from 'react';
import {Divider} from '@blueprintjs/core';

import {ReportSharingSettings} from '../../../../../models';
import {ENTITY_TYPE, WithGroupContainer} from '../../../../dialogs/SharingSettingsDialog';
import WithWorkspace from './WithWorkspace';
import WithUser from './WithUser';
import DatabaseInfoMessage from './DatabaseInfoMessage';
import CopyLink from './CopyLink';

interface ShareReportPopoverProps {
  uid: string;
  type?: string; // report type: default, notebook, embed
  sharingSettings: ReportSharingSettings;
  onChange?: (value: boolean) => void;
}


const ShareReportPopover: FunctionComponent<ShareReportPopoverProps> = ({
  uid,
  type,
  sharingSettings,
}: ShareReportPopoverProps) => {

  return (
    <div className="share-report__popover">
      <h4 className="bp4-heading share-report__popover__title">Share:</h4>
      <div className="share-report__popover__content">
        <WithWorkspace
          uid={uid}
          sharingSettings={sharingSettings}
        />
        <Divider/>
        <WithGroupContainer
          uid={uid}
          sharingSettings={sharingSettings}
          type={ENTITY_TYPE.REPORT}
        />
        <Divider/>
        <WithUser
          uid={uid}
          sharingSettings={sharingSettings}
        />
        <Divider/>
        <DatabaseInfoMessage/>
        <Divider/>
        <CopyLink
          uid={uid}
          type={type}
        />
      </div>
    </div>
  );
};

export default ShareReportPopover;
